/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import styled from 'styled-components';

import { colors, fonts } from '@theme/index';

export const TextDoubleStyled = styled.div`
    display: grid;
`;

export const TextDoubleSubtitleStyled = styled.span`
    ${fonts.textSmall};
    color: ${colors.tableCellTextColorSecondary};
`;
